import { LinkTo } from '@ember/routing';
import { PhSparkle, PhArrowRight, PhRocketLaunch } from 'ember-phosphor-icons';
import { t } from 'ember-intl';
import Tile from '../tile';

/**
 * Dashboard widget for Tio Reimagined preview (non-production only)
 * Shows a preview of the next-generation benefits experience
 */
const DashboardWidgetReimagined = <template>
  {{! template-lint-disable no-bare-strings }}
  <LinkTo @route="authenticated.reimagined">
    <Tile @headerText={{t "dashboard_tiles.career_pathways_title"}}>
      <:description>
        <span class="tio-row-tight mb-2">
          <PhSparkle class="text-teal-500" />
          <span class="text-teal-600 font-medium">{{t "dashboard_tiles.career_pathways_new"}}</span>
        </span>
        {{t "dashboard_tiles.career_pathways_description"}}
      </:description>
      <:image>
        <div
          class="w-full h-full tio-row-center tio-gradient-info-soft rounded-lg overflow-hidden relative"
        >
          {{! Animated sparkle background pattern }}
          <div class="absolute inset-0 opacity-20">
            <div class="absolute top-2 left-4 text-teal-400 animate-pulse">
              <PhSparkle @size={{16}} />
            </div>
            <div class="absolute top-6 right-8 text-cyan-400 animate-pulse animation-delay-500">
              <PhSparkle @size={{12}} />
            </div>
            <div class="absolute bottom-4 left-8 text-blue-400 animate-pulse animation-delay-1000">
              <PhSparkle @size={{14}} />
            </div>
            <div class="absolute bottom-8 right-4 text-teal-300 animate-pulse animation-delay-300">
              <PhSparkle @size={{10}} />
            </div>
          </div>
          <div class="text-center z-10">
            <div class="mx-auto w-16 h-16 rounded-2xl tio-gradient-info tio-row-center shadow-lg">
              <PhRocketLaunch class="tio-fg-inverse" @size={{32}} @weight="fill" />
            </div>
            <p class="text-sm text-teal-700 font-medium mt-3">{{t
                "dashboard_tiles.career_pathways_subtitle"
              }}</p>
          </div>
        </div>
      </:image>
      <:footer>
        <div class="tio-row-extra-tight text-teal-600 text-sm font-medium pr-2 pb-2">
          <span>{{t "dashboard_tiles.career_pathways_cta"}}</span>
          <PhArrowRight @size={{16}} />
        </div>
      </:footer>
    </Tile>
  </LinkTo>
</template>;

export default DashboardWidgetReimagined;
